(ns assemble.templates-page.drawer.view
  (:require ["@mui/material/Alert$default" :as Alert]
            ["@mui/material/Box$default" :as Box]
            ["@mui/material/Card$default" :as Card]
            ["@mui/material/CardContent$default" :as CardContent]
            ["@mui/material/Chip$default" :as Chip]
            ["@mui/material/Collapse$default" :as Collapse]
            ["@mui/material/Divider$default" :as Divider]
            ["@mui/material/Grid$default" :as Grid]
            ["@mui/material/Icon$default" :as Icon]
            ["@mui/material/IconButton$default" :as IconButton]
            ["@mui/material/Link$default" :as Link]
            ["@mui/material/Stack$default" :as Stack]
            ["@mui/material/Typography$default" :as Typography]
            [assemble.component.delete-template-modal :as delete-template]
            [assemble.component.drawer.hooks :as dh]
            [assemble.component.drawer.view :refer [drawer]]
            [assemble.component.move-modal.db :as move-modal.db]
            [assemble.resource.template :as resource.template]
            [assemble.templates-page.drawer.db :as db]
            [assemble.templates-page.upload-modal.db :as upload-modal.db]
            [clojure.set :as set]
            [common.resource.query.user :as uq]
            [common.util :refer [format-timestamp]]
            [common.widgets.form-field :refer [form-field]]
            [common.widgets.iframe.view :as iframe]
            [common.widgets.preview-container :refer [preview-container]]
            [common.widgets.status :as status]
            [common.widgets.template-preview :as template-preview]
            [re-frame.core :as rf]
            [uix.core :as uix :refer [$ defui]]))

(defui audit-result [{:keys [audit-result]}]
  (let [[expanded set-expanded] (uix/use-state false)]
    ($ Grid {:size #js {:xs 12}}
       ($ Card {:sx #js {:border 0
                         :boxShadow 0
                         :backgroundColor "grey.80"}}
          ($ CardContent
             ($ Stack {:direction "row" :gap 2}
                ($ Icon
                   {:color "error"
                    :sx #js {:fontSize "xxl"
                             :alignSelf "center"}}
                   "info")
                ($ Box {}
                   (let [{:keys [message]} (first audit-result)]
                     ($ Typography {:mb 1} message))
                   ($ Collapse {:in expanded}
                      (for [{:keys [message]} (rest audit-result)]
                        ($ Typography {:key message :mb 1} message)))
                   (when (> (count audit-result) 1)
                     ($ Link {:sx #js {:cursor "default"}
                              :onClick #(set-expanded (not expanded))}
                        (if expanded "See less information" "See more information"))))))))))

(defn has-preview-content [placeholders]
  (some (fn [[_k v]]
          (when (:preview_content v)
            true))
        placeholders))

(defn preview-content->export-content
  "Placeholders data is placeholder-key => {:previent_content, ...},
  the lemonpi code is looking for :value key."
  [placeholders]
  (into {}
        (map (fn [[k v]]
               [k (set/rename-keys v {:preview_content :value})])
             placeholders)))

(defui preview-iframe
  "Forwards ref to the iframe. The ref can be used to control the iframe."
  [{:keys [ref template has-preview-content w h]}]
  ($ iframe/iframe-new
     {:ref ref
      :src (str (:baseUrl (:latestRevision template)) "/index.html?_lemonpiPreview")
      :on-ready (fn [iframe]
                  ;; Sending empty data causes an error, so avoid sending if we have no preview-content.
                  (when has-preview-content
                    (iframe/post-lemonpi-config iframe (preview-content->export-content (:placeholders (:latestRevision template))))))
      :style {:border 0
              ;; Disable all pointer events in the iframe, i.e. the click.
              ;; Preview data can have a preview click action, but that would interfere with the preview.
              :pointer-events "none"}
      :height h
      :width w}))

(defui reload-button
  [{:keys [iframe-ref]}]
  ($ IconButton
     {:on-click (fn [_e]
                  (iframe/reload (.-current iframe-ref)))
      :sx #js {:color "grey.10"}}
     ($ Icon
        ;; Flip the icon to match the designs
        {:sx #js {:transform "scaleX(-1)"}}
        "replay")))

(defui preview [{{revision :latestRevision, :as template} :template}]
  (let [{:keys [templateType width height placeholders]} revision
        iframe-ref (uix/use-ref nil)]
    (if (= "after-effects" templateType)
      ($ template-preview/no-preview-possible {:reason-str "After Effects Template."})
      (let [has-preview-content (has-preview-content placeholders)]
        ($ Stack
           {:direction "column"
            :flexGrow 1
            :gap 1}
           ($ preview-container {:width (js/parseInt width)
                                 :height (js/parseInt height)
                                 :toolbar-buttons (when iframe-ref ($ reload-button {:iframe-ref iframe-ref}))
                                 :preview ($ preview-iframe
                                             {:ref iframe-ref
                                              :template template
                                              :has-preview-content has-preview-content
                                              :w (js/parseInt width)
                                              :h (js/parseInt height)})})
           (when-not has-preview-content
             ($ Alert
                {:severity "error"}
                "The template doesn't have preview content")))))))

(defui template-details [{:keys [latestRevision _archived creatorId createdAt updatedAt]}]
  (let [{:keys [width height templateType _baseUrl placeholders
                auditResult auditState]} latestRevision
        username (uq/use-user-id->user-name creatorId)
        mapping {"html" ["tv" "Display"]
                 "after-effects" ["ondemand_video" "Video"]}
        [type-icon type-text] (get mapping templateType)
        audit-mapping {"in progress" ["running" "grey.40"]
                       "passed" ["successful" "success.main"]
                       "failed" ["failed" "error.main"]
                       "errors" ["failed" "error.main"]}
        [audit-state audit-color] (get audit-mapping auditState)
        dimensions (if (or (boolean width) (boolean height))
                     (str width "x" height)
                     "Unknown")
        [expanded set-expanded] (uix/use-state false)]
    ($ :<>
       ($ form-field
          {:data-testid "dimensionsLabel"
           :label "Dimensions"}
          ($ Chip {:label dimensions}))

       (when audit-state
         ($ :<>
            ($ form-field
               {:label "Audit"}
               ($ status/simple {:color audit-color :status audit-state}))
            (when (seq auditResult)
              ($ audit-result {:audit-result auditResult}))))

       (when (seq placeholders)
         ($ form-field
            {:label "Placeholders"
             :sx #js {:maxWidth "100%"}}
            ($ Stack {:gap 0.5}
               ($ Collapse
                  {:in expanded
                   :collapsedSize "11rem"}
                  ($ Stack {:gap 0.5 :alignItems "flex-start"}
                     (for [placeholder placeholders]
                       (let [ph-name (clojure.core/name (key placeholder))
                             ph-type (:type (val placeholder))
                             icon (case ph-type
                                    "image" "image"
                                    "text" "text_fields"
                                    "video" "videocam"
                                    "audio" "music_note"
                                    "click" "link"
                                    nil)]
                         ($ Chip {:key ph-name
                                  :label ph-name
                                  :icon ($ Icon icon)
                                  :noWrap true})))))
               (when (> (count placeholders) 4)
                 ($ Link
                    {:sx #js {:cursor "pointer"}
                     :onClick #(set-expanded (not expanded))}
                    (if expanded "See less" "See all"))))))

       ($ form-field
          {:data-testid "typeLabel"
           :label "Template type"}
          ($ Stack {:direction "row" :gap 0.5}
             ($ Icon
                {:sx #js {:color "grey.50"}}
                type-icon)
             ($ Typography
                {:sx #js {:textTransform "uppercase"}}
                type-text)))

       ($ Divider)

       ($ form-field
          {:data-testid "creatorLabel"
           :label "Owner"}
          username)

       ($ form-field
          {:label "Created"}
          (format-timestamp createdAt "LL"))

       ($ form-field
          {:label "Updated"}
          (format-timestamp updatedAt "LL")))))

(defn template-linked-with-adset? [{:keys [revisions]}]
  (-> (some (comp seq :adsetIds) revisions)
      (boolean)))

(defui template-preview [{:keys [data]}]
  ($ Grid
     {:container true
      :size #js {:xs 12}
      :sx #js {:minWidth 0
               :flexDirection "row"}}
     ;; common.widgets.template-preview isn't general use template preview component,
     ;; it is completely specific to the adset-preview usecase, so it can't be used here.
     ($ preview {:template data})))

(defui templates-drawer []
  (let [{:keys [name folder-id archived latestRevision] :as data} (dh/use-drawer-templates-data)
        {:keys [templateId templateType]} latestRevision
        open? (dh/use-drawer-open? :file)
        on-close #(rf/dispatch [:assemble.templates-page/drawer-close])
        is-pre-made-template? (:pre-made-template data)]
    ($ drawer
       {:name name
        :drawer-type-label "template"
        :detail-view ($ template-details data)
        :preview-view ($ template-preview {:data data})
        :data data
        :allow-rename? (not is-pre-made-template?)
        :allow-editing? (not is-pre-made-template?)
        :on-rename (fn [new-value]
                     (js/Promise. (fn [resolve reject]
                                    (rf/dispatch [::db/rename-template resolve reject templateId new-value]))))
        :on-move #(rf/dispatch [::move-modal.db/open {:item-id templateId
                                                      :item-name name
                                                      :folder-id folder-id}])
        :on-archive #(rf/dispatch [::resource.template/archive-template templateId (not archived)])
        :archived? archived
        :show-more? true
        :more-options [{:title "Upload new revision"
                        :event-fn #(rf/dispatch [::upload-modal.db/open {:files nil
                                                                         :selected-template {:name name
                                                                                             :id templateId
                                                                                             :template-type templateType}
                                                                         :mode :new-revision}])}
                       {:title "Delete template"
                        :event-fn #(rf/dispatch [::delete-template/open-confirmation-modal templateId (template-linked-with-adset? data)])}]
        :open? open?
        :on-close on-close})))
